import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { User, LogOut, Sun, Moon } from '@/design-system/icons';
import { useUser, useTheme } from '@/app/providers';
import { useLogout } from '@/hooks/useLogout';
import {
  Dropdown,
  DropdownTriggerButton,
  DropdownContent,
  DropdownItem,
} from './Dropdown';

export function UserDropdown() {
  const { t } = useTranslation();
  const { user } = useUser();
  const { mode, toggleMode } = useTheme();
  const navigate = useNavigate();
  const { handleLogout } = useLogout();

  const handleMyAccount = () => {
    navigate({ to: '/profile' });
  };

  return (
    <Dropdown>
      <DropdownTriggerButton
        className="size-9 flex justify-center items-center rounded-full border-0 shadow-none text-muted hover:bg-surface-darker focus:outline-none focus:bg-surface-darker"
        aria-label={t('header.userMenu')}
      >
        <User className="size-4" />
      </DropdownTriggerButton>
      <DropdownContent className="sm:min-w-56 w-[calc(100vw-16px)] sm:w-auto">
        <div className="flex items-center gap-3 p-3 border-b border-border">
          <div className="size-10 flex items-center justify-center rounded-full bg-surface-darker">
            <User className="size-5 text-muted" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-medium text-onsurface truncate">
              {user?.name || t('sidebar.user')}
            </span>
            <span className="text-xs text-muted truncate">
              {user?.email}
            </span>
          </div>
        </div>

        <div className="py-1">
          <DropdownItem onSelect={handleMyAccount}>
            <User className="size-4 text-muted" />
            <span>{t('header.myAccount')}</span>
          </DropdownItem>
        </div>

        <div className="border-t border-border py-1">
          <DropdownItem onSelect={toggleMode}>
            {mode === 'light' ? (
              <Moon className="size-4 text-muted" />
            ) : (
              <Sun className="size-4 text-muted" />
            )}
            <span>{t('header.themeSwitch')}</span>
            <span className="ml-auto text-xs text-muted">
              {mode === 'light' ? t('theme.dark') : t('theme.light')}
            </span>
          </DropdownItem>
        </div>

        <div className="border-t border-border py-1">
          <DropdownItem onSelect={handleLogout}>
            <LogOut className="size-4 text-muted" />
            <span>{t('header.signOut')}</span>
          </DropdownItem>
        </div>
      </DropdownContent>
    </Dropdown>
  );
}
